import styled from 'styled-components';

export const Wrapper = styled.div``;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 16px 0;

  & > :first-child {
    margin-bottom: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
